<script>
	// import "@mediapipe/face_detection";
	import { route, resolution } from "./stores";
	import { onMount } from "svelte";
	import { LoginStates, States, Validators } from "./lib";
	import Ticker from "./Ticker.svelte";
	import LivenessModule from "./LivenessModule.svelte";
	import { TinyFaceDetectorOptions, nets, detectAllFaces } from "face-api.js";
	import * as StackBlur from "stackblur-canvas";
	import Dropdown from "./Dropdown.svelte";

	let displayHeight, displayWidth, canvas, video;
	let width, height;
	let debugLayer;
	let blurLayer;
	let faceD;
	let resizeCanvas;
	let cacheCanvas;
	let blurBackup;

	const TARGET_WIDTH = () =>
		document.body.clientWidth > document.body.clientHeight ? 1280 : 720;
	const TARGET_HEIGHT = () =>
		document.body.clientWidth > document.body.clientHeight ? 720 : 1280;

	let ready = {};
	const tinyFaceOptions = new TinyFaceDetectorOptions();
	onMount(async () => {
		if (
			"mediaDevices" in navigator &&
			navigator.mediaDevices.getUserMedia
		) {
			// var res = (await getResolutions()).map(res => {
			// 	return {
			// 		key: res.width + 'x' + res.height,
			// 		value: res.width + 'x' + res.height,
			// 		icon: ''
			// 	}
			// });
			var res = [];
			if (res.length == 0) {
				resolutions = [
					{ key: "1280x720", value: "1280x720", icon: "" },
				];
			} else {
				resolutions = res;
			}
			console.log(resolutions);
			$resolution = resolutions[0];
		}
		await nets.tinyFaceDetector.loadFromUri("./weights");
		await nets.faceLandmark68TinyNet.loadFromUri("./weights");
		await hookCamera();
		ready.component = true;
		return cleanup;
	});

	$: if (ready.component && ready.video) start();

	let resolutions = [];
	// $: ;
	let devices = [];
	let currentDevice = 0;
	let stream;

	function initCanvas() {
		var init = !ready.canvas;
		if (ready.video) {
			width = video.videoWidth;
			height = video.videoHeight;
		} else {
			var width = $resolution.key.split("x")[0];
			var height = $resolution.key.split("x")[1];
		}
		canvas.width = width;
		canvas.height = height;
		canvas.ctx = canvas.getContext("2d", { alpha: false });
		canvas.ctx.setTransform(1, 0, 0, 1, 0, 0);
		canvas.ctx.fillRect(0, 0, width, height);
		canvas.ctx.translate(width, 1);
		canvas.ctx.scale(-1, 1);

		debugLayer.width = width;
		debugLayer.height = height;
		debugLayer.ctx = debugLayer.getContext("2d", { alpha: true });

		blurLayer.width = width;
		blurLayer.height = height;
		blurLayer.ctx = blurLayer.getContext("2d", { alpha: true });

		if (init) cacheCanvas = document.createElement("canvas");
		cacheCanvas.width = width;
		cacheCanvas.height = height;
		cacheCanvas.ctx = cacheCanvas.getContext("2d", { alpha: true });

		if (init) blurBackup = document.createElement("canvas");
		blurBackup.width = width;
		blurBackup.height = height;
		blurBackup.ctx = blurBackup.getContext("2d", { alpha: true });

		if (init) resizeCanvas = document.createElement("canvas");
		resizeCanvas.width = width / 16;
		resizeCanvas.height = height / 16;
		resizeCanvas.ctx = resizeCanvas.getContext("2d", { alpha: true });

		ready.canvas = true;
	}
	function start() {
		console.log("start");
		// let ratio = video.videoWidth / video.videoHeight;
		initCanvas();
		videoLoop();
		recognizeLoop();
		blurLoop();
		loginState = LoginStates.IDLE;
		stateMask = States.NODATA;
	}

	function getResolutions() {
		var ResolutionsToCheck = [
			{ width: 320, height: 240 },
			{ height: 240, width: 320 },
			{ width: 640, height: 360 },
			{ height: 360, width: 640 },
			{ width: 640, height: 480 },
			{ height: 480, width: 640 },
			{ width: 768, height: 576 },
			{ height: 576, width: 768 },
			{ width: 1024, height: 576 },
			{ height: 576, width: 1024 },
			{ width: 1280, height: 720 },
			{ height: 720, width: 1280 },
			{ width: 1280, height: 768 },
			{ height: 768, width: 1280 },
			{ width: 1280, height: 800 },
			{ height: 800, width: 1280 },
			{ width: 1280, height: 900 },
			{ height: 900, width: 1280 },
			{ width: 1280, height: 1000 },
			{ height: 1000, width: 1280 },
			{ width: 1920, height: 1080 },
			{ height: 1080, width: 1920 },
			{ width: 1920, height: 1200 },
			{ height: 1200, width: 1920 },
		];

		function createTask() {
			var resolve, reject;

			var promise = new Promise(function (_resolve, _reject) {
				resolve = _resolve;
				reject = _reject;
			});

			promise.resolve = resolve;
			promise.reject = reject;
			return promise;
		}

		var results = [];
		var left = 0;
		var right = ResolutionsToCheck.length;
		var selectedWidth;
		var selectedHeight;
		var mid = 0;
		var s = createTask();

		function FindMaximum_WidthHeight_ForCamera() {
			if (left >= right) {
				results.pop();
				return s.resolve(results);
			}
			var temporaryConstraints = {
				audio: false,
				video: {
					width: {
						min: ResolutionsToCheck[left].width - 2,
						max: ResolutionsToCheck[left].width + 2,
					},
					height: {
						min: ResolutionsToCheck[left].height - 2,
						max: ResolutionsToCheck[left].height + 2,
					},
				},
			};
			console.log(temporaryConstraints);

			var kek = left + 0;
			navigator.mediaDevices
				.getUserMedia(temporaryConstraints)
				.then((stream) => checkSuccess(stream, kek))
				.catch(checkError);
			left = left + 1;
			return s;
		}

		function checkSuccess(stream, ee) {
			results.push(ResolutionsToCheck[ee]);

			for (let track of stream.getTracks()) {
				track.stop();
			}

			FindMaximum_WidthHeight_ForCamera();
		}
		function checkError(error) {
			FindMaximum_WidthHeight_ForCamera();
		}
		return FindMaximum_WidthHeight_ForCamera();
	}

	function fitToRegion(region, image) {
		let scaled;
		if (region.height / region.width >= image.height / image.width) {
			scaled = {
				width: image.width,
				height: region.height * (image.width / region.width),
			};
		} else {
			scaled = {
				width: region.width * (image.height / region.height),
				height: image.height,
			};
		}
		scaled.x = (image.width - scaled.width) / 2;
		scaled.y = (image.height - scaled.height) / 2;
		return scaled;
	}

	function videoLoop() {
		const height = video.videoHeight;
		const width = video.videoWidth;
		const scaled = fitToRegion({ height, width }, canvas);
		canvas.ctx.drawImage(
			video,
			0,
			0,
			width,
			height,
			0,
			0,
			width,
			height
			// scaled.x, scaled.y,
			// scaled.width, scaled.height
		);

		videoLoop.timeout = requestAnimationFrame(videoLoop);
	}

	async function recognizeLoop() {
		handleResults(
			await detectAllFaces(canvas, tinyFaceOptions).withFaceLandmarks(
				true
			)
		);
		recognizeLoop.timeout = setTimeout(recognizeLoop, 80);
	}

	async function blurLoop() {
		cacheCanvas.ctx.globalCompositeOperation = "source-over";
		cacheCanvas.ctx.clearRect(0, 0, cacheCanvas.width, cacheCanvas.height);
		resizeCanvas.ctx.clearRect(
			0,
			0,
			resizeCanvas.width,
			resizeCanvas.height
		);
		resizeCanvas.ctx.drawImage(
			canvas,
			0,
			0,
			canvas.width,
			canvas.height,
			0,
			0,
			resizeCanvas.width,
			resizeCanvas.height
		);
		StackBlur.canvasRGB(
			resizeCanvas,
			0,
			0,
			resizeCanvas.width,
			resizeCanvas.height,
			2
		);
		cacheCanvas.ctx.drawImage(
			resizeCanvas,
			0,
			0,
			resizeCanvas.width,
			resizeCanvas.height,
			0,
			0,
			cacheCanvas.width,
			cacheCanvas.height
		);
		blurBackup.ctx.drawImage(cacheCanvas, 0, 0);
		cacheCanvas.ctx.globalCompositeOperation = "xor";
		cacheCanvas.ctx.beginPath();
		cacheCanvas.ctx.fillStyle = "white";
		cacheCanvas.ctx.ellipse(
			cacheCanvas.width / 2,
			cacheCanvas.height / 2.5,
			cacheCanvas.height / 3,
			cacheCanvas.height / 4,
			Math.PI / 2,
			0,
			2 * Math.PI
		);
		cacheCanvas.ctx.fill();
		blurLayer.ctx.clearRect(0, 0, blurLayer.width, blurLayer.height);
		blurLayer.ctx.drawImage(cacheCanvas, 0, 0);
		blurLoop.timeout = setTimeout(blurLoop, 45);
	}

	// $: if ($resolution) hookCamera();
	async function hookCamera(device) {
		initCanvas();
		try {
			stream.getTracks().forEach((track) => track.stop());
			ready.video = false;
		} catch (error) {}

		try {
			if (
				"mediaDevices" in navigator &&
				navigator.mediaDevices.getUserMedia
			) {
				const constraints = {
					video: {
						facingMode: {
							ideal: "user",
						},
						width: {
							min: 480,
							ideal: TARGET_WIDTH(),
						},
						height: {
							min: 480,
							ideal: TARGET_HEIGHT(),
						},
						frameRate: {
							min: 2,
							ideal: 30,
						},
					},
				};
				if (device)
					constraints.video.deviceId = {
						exact: devices[currentDevice].deviceId,
					};
				stream = await navigator.mediaDevices.getUserMedia(constraints);
				devices = (
					await navigator.mediaDevices.enumerateDevices()
				).filter(
					(d) => d.kind == "videoinput" //&&
					// !d.label.toLowerCase().includes("virtual")
				);
				window._strem = stream;
				currentDevice = devices.findIndex(
					(d) =>
						d.deviceId ==
						stream.getTracks()[0].getSettings().deviceId
				);

				video.onloadeddata = () => {
					ready.video = true;
					start();
				};
				video.srcObject = stream;
				//video.pause();
				video.play();
			} else {
				alert("Camera not supported.");
			}
		} catch (e) {
			console.error(e);
			alert("Device is busy or not supported.");
		}
	}

	function toggleCamera() {
		currentDevice = devices[currentDevice + 1] ? currentDevice + 1 : 0;
		console.log(devices[currentDevice]);
		hookCamera(devices[currentDevice]);
	}

	let stateMask = States.NODATA;
	let certainRect;

	let rollingStack = [];
	let ROLLING_STACK_SIZE = 20;
	function handleResults(results) {
		rollingStack.push(results);
		if (rollingStack.length > ROLLING_STACK_SIZE) rollingStack.shift();

		if (rollingStack.reduce((a, b) => a + b.length, 0) < 1)
			return (stateMask = States.NOFACE);

		const r = results[0];
		if (!r) return;

		debugLayer.ctx.fillStyle = "magenta";
		debugLayer.ctx.clearRect(0, 0, canvas.width, canvas.height);
		r.landmarks._positions.forEach((p, i) => {
			debugLayer.ctx.fillRect(p._x - 2, p._y - 2, 3, 3);
			// debugLayer.ctx.fillText(i, p._x, p._y)
		});

		if (results.length > 1) return (stateMask = States.TWOFACE);
		if (Validators.size(r, canvas) < 0) return (stateMask = States.TOOFAR);
		if (Validators.size(r, canvas) > 0) return (stateMask = States.TOONEAR);
		if (
			Validators.pan(r, canvas) > 0 ||
			Validators.pan(r, canvas) < 0 ||
			Validators.position(r, canvas) < 0
		)
			return (stateMask = States.NOTSTRAIGHT);
		stateMask = 0;
		certainRect = r.alignedRect._box;
	}

	let loginState = LoginStates.IDLE;

	$: stateWatcher(stateMask);
	function stateWatcher(mask) {
		if (loginState == LoginStates.SUCCESS) {
			return;
		}
		if (mask === 0) {
			loginState = LoginStates.COUNTING;
			stateWatcher.acceptTimeout = setTimeout(() => {
				loginState = LoginStates.SUCCESS;
				cleanup();
			}, 2000);
			return;
		}
		clearTimeout(stateWatcher.acceptTimeout);
		loginState = LoginStates.IDLE;
	}

	function cleanup() {
		cancelAnimationFrame(videoLoop.timeout);
		clearTimeout(recognizeLoop.timeout);
		clearTimeout(blurLoop.timeout);
		stateMask = 0;
	}

	// let snap;
	// function doSnap(loginState) {
	// 	let c = document.createElement('canvas');
	// 	c.ctx = c.getContext('2d');
	// 	c.width = certainRect._width;
	// 	c.height = certainRect._height * 1.5;
	// 	c.ctx.drawImage(
	// 		canvas,
	// 		certainRect._x, certainRect._y - certainRect._height * 0.5,
	// 		certainRect._width, certainRect._height * 1.5,
	// 		0,0,
	// 		c.width, c.height
	// 	)
	// 	snap.innerHTML = '';
	// 	snap.appendChild(c);
	// 	setTimeout(() => {
	// 		loginState = 0;
	// 		stateWatcher(stateMask)
	// 	}, 500)
	// }
	// $: if(certainRect && loginState == 1) doSnap(loginState)
</script>

<div
	class="Camera"
	bind:offsetHeight={displayHeight}
	bind:offsetWidth={displayWidth}
>
	<button
		class="button-float"
		data-icon="keyboard_arrow_left"
		on:click={() => {
			cleanup();
			$route = "";
		}}>Back</button
	>
	{#if resolutions.length > 0 && ready.video}
		<Dropdown
			items={resolutions}
			placeholder="Upper resolution limit"
			bind:selected={$resolution}
			key={resolutions[0].key}
		/>
	{/if}
	<video bind:this={video} autoplay="" muted="" playsinline="" />
	<canvas bind:this={canvas} />
	<canvas class="debug" bind:this={debugLayer} />
	<canvas class="blur" bind:this={blurLayer} />
	<Ticker {stateMask} {loginState} />
	{#if loginState == LoginStates.SUCCESS}
		<LivenessModule
			image={canvas}
			background={blurBackup}
			on:reset={start}
		/>
	{:else if devices.length > 1}
		<button
			class="button"
			style="left: 50%; transform: translateX(-50%); bottom: 1em; position: absolute"
			on:click={toggleCamera}>Switch camera</button
		>
	{/if}
	<!-- <div class="snap" bind:this={snap}> -->
	<!-- </div> -->
</div>

<style>
	.Camera {
		position: relative;
		background: black;
	}

	canvas {
		display: block;
		/*transform: scaleX(-1);*/
		max-height: 100vh;
		min-height: 100vh;
		min-width: unset;
		left: 50%;
		transform: translateX(-50%);
		position: absolute;
		top: 0;
	}
	canvas.debug {
		position: absolute;
		top: 0;
		mix-blend-mode: overlay;
		pointer-events: none;
	}
	canvas.blur {
		position: absolute;
		top: 0;
		pointer-events: none;
	}

	video {
		display: none;
	}
	/*
	.snap {
		position: absolute;
		transform: translateX(-130%) translateY(-50%);
		top: 50%;
	}
*/

	.button {
		background: #ab1e8a99;
		border: none;
		border-radius: 4px;
		color: white;
		padding: 0.7em 1.5em;
		min-width: 10em;
		cursor: pointer;
	}

	.button-float {
		background: rgba(10, 10, 10, 0.4);
		color: white;
		font-size: 1.2em;
		position: absolute;
		border: none;
		border-bottom: 1px solid rgba(255, 255, 255, 0.2);
		width: 100%;
		text-align: left;
		padding: 0;
		line-height: 2.4em;
		padding-left: 0.5em;
		margin: 0;
		cursor: pointer;
		z-index: 2;
	}
	.button-float:hover {
		background: rgba(0, 0, 0, 0.5);
	}

	.Camera :global(.Dropdown) {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		top: 2px;
		z-index: 50;
		min-width: 15em !important;
	}
</style>
